import { useEffect } from 'react'
import { ArrowRight } from 'lucide-react'
import { useAssessment } from '../../context/AssessmentContext'
import Shell from '../ui/Shell'
import { pulse } from '../ui/LightField'

function WelcomeScreen() {
  const { state, dispatch } = useAssessment()
  const resuming = state.selectedAddictions.length > 0

  useEffect(() => {
    pulse(0.9, { x: 0.75, y: 0.3 })
  }, [])

  const begin = () => {
    pulse(1.2, { x: 0.5, y: 0.8 })
    dispatch({ type: 'SET_SCREEN', payload: 'ageCollection' })
  }
  const reset = () => dispatch({ type: 'RESET_ASSESSMENT' })

  return (
    <Shell bare>
      <main className="welcome">
        <div className="welcome__brand">
          <img src="/images/logo.svg" alt="" className="logo-mark" />
          <span className="welcome__wordmark">BetterStep</span>
        </div>

        <h1 className="welcome__title">How are you, <em>really</em>?</h1>

        <div className="welcome__actions">
          <button type="button" className="btn btn--hero btn--block" onClick={begin}>
            {resuming ? 'Continue' : 'Start'}
            <ArrowRight size={20} strokeWidth={2.25} />
          </button>
          {resuming && (
            <button type="button" className="btn btn--secondary btn--block" onClick={reset}>
              Start over
            </button>
          )}
          <p className="welcome__meta" aria-label="Five minutes, private, results by email">
            <span>5 min</span>
            <span aria-hidden="true">·</span>
            <span>Private</span>
            <span aria-hidden="true">·</span>
            <span>Results by email</span>
          </p>
        </div>
      </main>
    </Shell>
  )
}

export default WelcomeScreen
